<template>
  <el-container class="el-menu-container">
    <el-header>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            router
            @select="handleSelect"
          >
            <el-menu-item >稽查部监督举报网络平台</el-menu-item>
            <el-menu-item index="/login">后台管理</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="4"></el-col>
      </el-row>
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      islogin: false
    };
  },

  created() {
    if (sessionStorage.getItem("token")) {
      this.islogin = true;
    }
  }
};
</script>

<style lang="less" scoped>
.el-menu-container {
  height: 100%;
}
.el-tuichu {
  float: right;
  margin: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/index/Index.vue